define([
	"dojo/_base/declare",
	"csi/_base/storage",
	"csi/comm",
	"csi/view/ToolbarPluginSwitchboard",
	"csi/xml",
	"csi/xml/Query",
	"Merchandising/SecondaryDisplay/CustomViewSecondaryDisplayOptions",
], function(declare, storage, comm, ToolbarPluginSwitchboard, xml, Query, CustomViewSecondaryDisplayOptions) {

	return declare(ToolbarPluginSwitchboard, {
		idViewProperty: "activeMerchSecondaryType",
		switchboardPath: "Child:__Parent__/Child:Plan/Child:Subtype/Child:Settings/Child:SecondarySubtypes",

		/**
		 * Return true if the custom view option for secondary display type is not 0 (disabled) and the matrix is selected
		 * @return {boolean}
		 */
		canShowPlugin() {
			return this.getView().isShowingSecondaries();
		},

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			view.set("urlSecondaryType", node ? node.$URL : null);
			var _urlSecondaryType = view.get("urlSecondaryType");

			storage.set("MerchSecondaryPlanSubtype", _urlSecondaryType);
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		},

		/**
		 * @override
		 * Adding NodeType to the Query
		 */
		_getStoreOptions: function(url, r) {
			const options = this.inherited(arguments);
			const request = options?.request;
			if (request) {
				request.setBinaryQuery(comm.QUERY_XML, new Query().Node("Type", xml.OP_EQUALS, options.typeNode));
			}

			return options;
		},
	});
});